import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Hero from 'components/Hero';
import CategoriesSection from 'components/CategoriesSection';
import FeaturedGear from 'components/FeaturedGear';
import ProcessSection from 'components/ProcessSection';
import ContactCTA from 'components/ContactCTA';
import { getCategoriesWithEquipment } from 'api/strapi';

function flattenEquipment(categories) {
  return categories.flatMap((category) =>
    (category.equipment || []).map((item) => ({
      ...item,
      categoryName: category.name,
      categorySlug: category.slug,
    }))
  );
}

function Home() {
  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    getCategoriesWithEquipment()
      .then((response) => {
        if (!cancelled) {
          setCategories(response.data || []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const equipment = flattenEquipment(categories);
  const featuredItems = equipment.slice(0, 5);

  return (
    <>
      <Hero itemCount={equipment.length || null} />
      {loading && (
        <p className="status-message container">{t('states.loadingCatalog')}</p>
      )}
      {error && (
        <p className="status-message status-message--error container">
          {t('states.loadCatalogError', { error })}
        </p>
      )}
      {!loading && !error && categories.length > 0 && (
        <>
          <CategoriesSection categories={categories} />
          <FeaturedGear items={featuredItems} />
        </>
      )}
      {!loading && !error && categories.length === 0 && (
        <p className="status-message container">{t('states.noCategories')}</p>
      )}
      <ProcessSection />
      <ContactCTA />
    </>
  );
}

export default Home;
